import { Drawer } from "@circleco/compass/components/Drawer";

import { t } from "@/i18n-js/instance";
import { LazyMemberChecklistContent } from "@/react/components/MemberChecklist/LazyMemberChecklistContent";

interface MobileMemberChecklistDrawerContentProps {
  enabled: boolean;
  onClose: () => void;
}

const rootLocale = "header.member_checklist";

export const MobileMemberChecklistDrawerContent = ({
  enabled,
  onClose,
}: MobileMemberChecklistDrawerContentProps) => (
  <>
    <Drawer.Header title={t([rootLocale, "title"])} sticky />
    <LazyMemberChecklistContent
      enabled={enabled}
      closeChecklist={onClose}
      className="px-1"
    />
  </>
);
